module.exports = __webpack_public_path__ + "media/images/icons/icons_small/26_bikefortwo-e2bb1778e9117d11c4b227d0511d4bef.png";